module.exports = __webpack_public_path__ + "img/22.fbaab176.jpg";